import React from 'react';
// import { Tooltip } from '@mui/material';
import { styled } from '@mui/system';
import { Tooltip } from 'antd';


const CustomTextLimit = ({ text, title, limit, oneLineMax }) => {
    const TextWithEllipsis = styled(title ? 'h5' : 'p')({
        display: '-webkit-box',
        overflow: 'hidden',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: oneLineMax ? 1 : 2,
        textOverflow: 'ellipsis',
        fontFamily: 'Poppins'
    });
    const charLimit = limit || 120;
    return (
        <>
            {text?.length > charLimit ? (
                <Tooltip overlayStyle={{ maxWidth: '500px' }} title={text}>
                    <TextWithEllipsis>
                        {text}
                    </TextWithEllipsis>
                </Tooltip>
            ) : (
                <TextWithEllipsis>
                    {text}
                </TextWithEllipsis>
            )}
        </>
    );
};

export default CustomTextLimit;
